import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

export interface SocketDeviceIdentity {
  device_id: string;
  app_session_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceIdentityService {
  private readonly localStorageService: LocalStorageService = inject(LocalStorageService);
  private readonly deviceIdStorageKey: string = 'pyjam.device_id';
  private readonly appSessionId: string = this.createIdentifier('session');

  public getIdentity(): SocketDeviceIdentity {
    return {
      device_id: this.getDeviceId(),
      app_session_id: this.appSessionId,
    };
  }

  private getDeviceId(): string {
    const storedDeviceId: unknown = this.localStorageService.getItem(this.deviceIdStorageKey);
    if (typeof storedDeviceId === 'string' && storedDeviceId.trim().length > 0) {
      return storedDeviceId;
    }

    const deviceId: string = this.createIdentifier('device');
    this.localStorageService.setItem(this.deviceIdStorageKey, deviceId);
    return deviceId;
  }

  private createIdentifier(prefix: string): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return `${prefix}:${crypto.randomUUID()}`;
    }

    const timestamp: string = Date.now().toString(36);
    const random: string = Math.random().toString(36).slice(2);
    return `${prefix}:${timestamp}-${random}`;
  }
}
